import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useSeo, fmtDate } from "@/lib/seo";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [cat, setCat] = useState("All");
  const [loading, setLoading] = useState(true);

  useSeo({
    title: "Fishing Guides & Blog | Furn Angling",
    description: "Carp fishing tips, rig guides, bait advice, product reviews and session reports from the Furn Angling team. Expert specialist angling content.",
  });

  useEffect(() => {
    api.get("/blog").then((r) => { setPosts(r.data.posts); setCategories(r.data.categories); }).finally(() => setLoading(false));
  }, []);

  const shown = cat === "All" ? posts : posts.filter((p) => p.category === cat);

  return (
    <div className="container-furn py-12">
      <div className="mb-8 border-b border-border pb-6">
        <span className="overline">From the bank</span>
        <h1 className="mt-1 font-display text-4xl font-bold uppercase tracking-tight md:text-5xl">Fishing Guides & Blog</h1>
        <p className="mt-2 max-w-xl text-muted-foreground">Tips, rig guides, bait advice, reviews and session reports from the Furn Angling team.</p>
      </div>

      <div className="mb-8 flex flex-wrap gap-2">
        {["All", ...categories].map((c) => (
          <button key={c} onClick={() => setCat(c)} data-testid={`blog-cat-${c}`} className={`border px-4 py-2 text-xs font-bold uppercase tracking-widest transition-colors ${cat === c ? "border-accent text-accent" : "border-border text-muted-foreground hover:border-accent/50"}`}>{c}</button>
        ))}
      </div>

      {loading ? (
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">{Array.from({ length: 6 }).map((_, i) => <div key={i} className="aspect-[4/3] animate-pulse bg-secondary" />)}</div>
      ) : shown.length === 0 ? (
        <p className="py-16 text-center text-muted-foreground">No posts in this category yet.</p>
      ) : (
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="blog-grid">
          {shown.map((post, i) => (
            <Link key={post.slug} to={`/blog/${post.slug}`} data-testid={`blog-card-${post.slug}`} className="group border border-border bg-card transition-colors hover:border-primary animate-fade-up" style={{ animationDelay: `${(i % 6) * 60}ms` }}>
              <div className="aspect-[4/3] overflow-hidden bg-secondary"><img src={post.image} alt={post.title} className="zoom-img h-full w-full object-cover" /></div>
              <div className="p-5">
                <span className="overline">{post.category}</span>
                <h3 className="mt-2 font-display text-lg font-medium leading-snug group-hover:text-accent transition-colors">{post.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{post.excerpt}</p>
                <p className="mt-3 text-xs text-muted-foreground">{post.read} read · {fmtDate(post.date)}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
